<template>
  <div id="loginPage">
    <div id="leftCardLogin">
      <canvas id="canvas"></canvas>
    </div>
    <div id="rightCardLogin">
      <div id="loginLogo">
        <img src="@/assets/logo_tesfri_black.png" alt="TS" class="logo img-fluid" />
      </div>
      <div id="loginForm">
        <p>Bienvenue ! Accédez à votre compte.</p>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <v-form @submit.stop.prevent="handleSubmit(onSubmit)">
            <validation-provider name="company" :rules="{ required: true }" v-slot="validationContext">
              <v-text-field
                id="input-company"
                v-model="form.company"
                placeholder="Code société"
                type="text"
                trim
                :state="getValidationState(validationContext)"
              ></v-text-field>
            </validation-provider>
            <validation-provider name="warehouse" :rules="{ required: true }" v-slot="validationContext">
              <v-text-field
                id="input-warehouse"
                v-model="form.warehouse"
                placeholder="Code site"
                type="text"
                trim
                :state="getValidationState(validationContext)"
              ></v-text-field>
            </validation-provider>
            <validation-provider name="login" :rules="{ required: true }" v-slot="validationContext">
              <v-text-field
                id="input-login"
                v-model="form.login"
                placeholder="Identifiant"
                type="text"
                trim
                :state="getValidationState(validationContext)"
              ></v-text-field>
            </validation-provider>
            <validation-provider name="password" :rules="{ required: true }" v-slot="validationContext">
              <v-text-field
                id="input-password"
                v-model="form.password"
                placeholder="Mot de passe"
                type="password"
                trim
                :state="getValidationState(validationContext)"
              ></v-text-field>
              <!-- <v-form-invalid-feedback id="input-password-live-feedback">test</v-form-invalid-feedback> -->
            </validation-provider>
            <v-btn type="submit" block>Connexion</v-btn>
          </v-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
//import { required } from "vuelidate/lib/validators";

export default {
  name: "Login",
  computed: {
    ...mapState("userContext", ["companies", "authToken"]),

    nameState() {
      return this.form.name.length > 2 ? true : false;
    }
  },

  data() {
    return {
      form: {
        login: "",
        password: "",
        company: "",
        warehouse: ""
      }
    };
  },
  // validations: {
  //   form: {
  //     login: { required },
  //     password: { required },
  //     warehouse: { required },
  //     company: { required }
  //   }
  // },
  methods: {
    ...mapActions("userContext", ["login", "isAuthenticated"]),

    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },

    onSubmit() {
      //TOOD : customizer la validation
      //evt.preventDefault();
      // redirection par default sur la page d'accueil
      let urlredirect = "/";
      if (this.$route.query.redirectUri != undefined) {
        urlredirect = this.$route.query.redirectUri;
      }
      this.login(this.form)
        .then(() => this.$router.replace(urlredirect))
        .catch(error => {
          //TODO : ajouter un message d'erreur sur la page
          alert("error login.....");
          Vue.$log.error(error);
        });
    },

    dessiner() {
      // fonction pour la partie dessin de gauche
      var canvas = document.getElementById("canvas");
      var ctx = canvas.getContext("2d");

      ctx.canvas.width = window.innerWidth;
      ctx.canvas.height = window.innerHeight;

      var largeurCtx = ctx.canvas.width / 2;
      var hauteurCtx = ctx.canvas.height / 2;

      ctx.strokeStyle = "#C13660";
      ctx.lineCap = "round";
      ctx.lineWidth = 75;
      ctx.beginPath();
      ctx.arc(-10, hauteurCtx + 150, hauteurCtx / 2, 0, 100, false);
      ctx.stroke();

      ctx.strokeStyle = "#ec406f";
      ctx.lineCap = "round";
      ctx.lineWidth = 75;
      ctx.beginPath();
      ctx.arc(largeurCtx, hauteurCtx, hauteurCtx, 100, 0, true);
      ctx.stroke();
    }
  },

  mounted() {
    this.dessiner();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "login.scss";
</style>
